import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceTask } from '@era/device-task-management-sdk';
import { DevicesRouterStoreSelectors } from '@era/stores';
import { HubConnection } from '@microsoft/signalr';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';
import { DeviceTaskManagementHubService } from './device-task-management-hub.service';
import { DeviceScheduledTasksStoreActions } from '../../sub-features/device-sync/device-scheduled-tasks-store';

@Injectable()
export class DeviceScheduledTasksSignalR {
  private readonly hubConnection: HubConnection;

  constructor(
    private readonly routerStore: Store<Router>,
    private readonly zone: NgZone,
    locationsHubService: DeviceTaskManagementHubService,
    private readonly scheduledTasksStore: Store<DeviceTask>
  ) {
    this.hubConnection = locationsHubService.hubConnection;
    this.initialize();
  }

  private initialize() {
    this.hubConnection.on('RefreshTaskQueue', (udid: string) => {
      this.zone.run(() => {
        this.routerStore
          .select(DevicesRouterStoreSelectors.selectUdid)
          .pipe(
            map((currentUdid) => currentUdid === udid),
            take(1)
          )
          .subscribe((isUdidSelected) => {
            if (isUdidSelected) {
              this.scheduledTasksStore.dispatch(
                DeviceScheduledTasksStoreActions.SignalRActions.scheduledTasksUpdated({ udid })
              );
            }
          });
      });
    });
  }
}
